import {Components} from '@exp1/front-utils'

export const Sidebar = () => {
  return (
    <div className="flex flex-col gap-4 border rounded p-4 w-64 h-min">
      <Components.StandardLink to="/users">Users</Components.StandardLink>
      <Components.StandardLink to="/services">Services</Components.StandardLink>
      <Components.StandardLink to="/roles">Roles</Components.StandardLink>
      <Components.StandardLink to="/permissions">Permissions</Components.StandardLink>
      <Components.StandardLink to="/locations">Locations</Components.StandardLink>
    </div>
  )
}
